import React, { useState } from 'react'
import { InputGroup, InputGroupText, Input, Badge } from 'reactstrap';


export default function PrivateSeller({ firstName, setFirstName, lastName, setLastName, adress, setAdress, zipcode, setZipCode, city, setCity, country, setCountry,
    email, setEmail, phone, setPhone, setAddressLine2, addressLine2, setKontoinhaber, kontoinhaber, setIban, iban, setBic, bic, setNameDerBank, nameDerBank }) {
    // const [firstName, setFirstName] = useState('')
    // const [lastName, setLastName] = useState('')
    // const [adress, setAdress] = useState('')
    // const [zipcode, setZipCode] = useState('')
    //const [city, setCity] = useState('')
    //const [country, setCountry] = useState('')
    //const [email, setEmail] = useState('')
    //const [phone, setPhone] = useState('')

    return (
        <div>
            <h5 className="mb-4">Kundeninfo</h5>
            <div className="d-flex justify-content-between mb-2">
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Vorname:
                    </InputGroupText>
                    <Input
                        value={firstName}
                        onChange={e => setFirstName(e.target.value)}
                    //onInput={e => props.setPrivateSellerInfo.name(e.target.value)}
                    //value=
                    //onChange={()=>{
                    //let copyOfState = [props.privateSellerInfo];
                    //copyOfState.fNam= value;
                    //props.setPrivateSellerInfo(copyOfState);
                    // }} 
                    />
                    {console.log(firstName)}
                </InputGroup>
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Nachname:*
                    </InputGroupText>
                    <Input
                        value={lastName}
                        onChange={e => setLastName(e.target.value)}
                    />
                </InputGroup>
                <InputGroup className="">
                    <InputGroupText>
                        Adresse:
                    </InputGroupText>
                    <Input
                        value={adress}
                        onChange={e => setAdress(e.target.value)}
                    />
                </InputGroup>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Adresszeile 2:
                    </InputGroupText>
                    <Input
                        value={addressLine2}
                        onChange={e => setAddressLine2(e.target.value)} />
                </InputGroup>
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Postleitzahl:
                    </InputGroupText>
                    <Input
                        value={zipcode}
                        onChange={e => setZipCode(e.target.value)} />
                </InputGroup>
                <InputGroup className="">
                    <InputGroupText>
                        Stadt:
                    </InputGroupText>
                    <Input
                        value={city}
                        onChange={e => setCity(e.target.value)}
                    />
                </InputGroup>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Ländercode:
                    </InputGroupText>
                    <Input
                        maxLength="2"
                        value={country}
                        onChange={e => setCountry(e.target.value)}
                    />
                </InputGroup>
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Email:
                    </InputGroupText>
                    <Input
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                </InputGroup>
                <InputGroup className="">
                    <InputGroupText>
                        Telefon:
                    </InputGroupText>
                    <Input
                        value={phone}
                        onChange={e => setPhone(e.target.value)} />
                </InputGroup>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Kontoinhaber:
                    </InputGroupText>
                    <Input
                        value={kontoinhaber}
                        onChange={e => setKontoinhaber(e.target.value)}
                    />
                </InputGroup>
                <InputGroup className="mr-5">
                    <InputGroupText>
                        IBAN:
                    </InputGroupText>
                    <Input
                        value={iban}
                        onChange={e => setIban(e.target.value)}
                    />
                </InputGroup>
                <InputGroup className="">
                    <InputGroupText>
                        BIC:
                    </InputGroupText>
                    <Input
                        value={bic}
                        onChange={e => setBic(e.target.value)}
                    />
                </InputGroup>
            </div>
            <div className="d-flex justify-content-between">
                <InputGroup className="" style={{ width: "30.5%" }}>
                    <InputGroupText>
                        Name der Bank:
                    </InputGroupText>
                    <Input
                        value={nameDerBank}
                        onChange={e => setNameDerBank(e.target.value)} />
                </InputGroup>
            </div>
        </div>
    )
}
